export class SoapShareNavigationSection {
    // staff
    doc;
    nav;

    constructor() {
        this.init();
    }

    init() {
        this.doc = $(document);
        this.nav = $('.share-navigation-section');

        if (!this.nav.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.nav.on('click', (e) => this.navigationEnable(e));
        this.doc.on('click', () => this.navigationDisable());
    }

    navigationEnable(e) {
        $(e.currentTarget).addClass('share-navigation-section--active');
        e.stopPropagation();
    }

    navigationDisable() {
        this.nav.removeClass('share-navigation-section--active');
    }
}
